import React from 'react'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'

import styles from './PaintingSection.module.scss'

const PaintingSection = ({ painting }) => (
    <div className={styles.paintingSection}>
        <LazyLoad height="100%" offset={500} once classNamePrefix="painting">
            <img alt="" src={painting} />
        </LazyLoad>
        <p className={styles.caption}>Untitled (1bc639f5-fcc): Detail, STiCH, 2020</p>
    </div>
)

PaintingSection.propTypes = {
    painting: PropTypes.string.isRequired,
}

export default PaintingSection
